export default {
	/**
	 * Set survey targets
	 * @param {Array} survey_targets 
	 */
	all(state, survey_targets) {
		state.all = survey_targets
	},
}
